<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item to="/audit-task-setting/table">审单管理</el-breadcrumb-item>
        <el-breadcrumb-item>审单系统配置</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $route.meta.title }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel>
      <template slot="header">审单系统配置</template>
      <el-form
        ref="form"
        :model="form"
        :rules="formRules"
        class="form-content-half"
        size="medium"
        label-width="140px"
      >
        <el-form-item label="客户"
                      prop="customerid">
          <remote-select
            v-model="form.customerid"
            placeholder="请输入客户名称/编号搜索"
            :query-request="getCustomerTable"
            :find-request="getCustomerDetail"
            @change="onCustomerChanged"
            :disabled="!!form.id"
          />
        </el-form-item>

        <el-form-item label="项目"
                      prop="projectid">
          <remote-select
            placeholder="请输入项目名称/编号搜索"
            v-model="form.projectid"
            :disabled="!form.customerid || !!form.id"
            :query-request="getBaiscProjectTable"
            :query-params="{ customerid: form.customerid }"
            :find-request="getProjectDetail"
            @change="onProjectChanged"
          />
        </el-form-item>

        <el-form-item label="以项目维度审单">
          <el-switch
            v-model="form.setting_config_json.is_project_audit"
            :active-value="1"
            :inactive-value="0"
          />
        </el-form-item>

        <el-divider/>

        <el-form-item label="批次选择">
          <remote-select
            v-model="selectedBatchIds"
            :multiple="true"
            :multiple-limit="50"
            placeholder="请输入批次关键字"
            :disabled="!form.projectid"
            label-key="detail"
            :query-request="getBatchTable"
            :query-params="{ customerid: form.customerid, projectid: form.projectid }"
            :find-request="getBatchDetail"
          />
        </el-form-item>

        <el-form-item label="批次配置">
          <el-table
            :data="form.setting_config_json.batch_audit_cfg"
            border
            size="mini"
            style="width: 100%">
            <el-table-column prop="batchid"
                             label="批次ID"
                             min-width="120"/>
            <el-table-column label="开启金标"
                             min-width="160">
              <template slot-scope="scope">
                <el-switch
                  v-model="scope.row.enable_exam_task"
                  :active-value="1"
                  :inactive-value="0"
                  @change="onEnableExamTaskChange(scope.row)" />
              </template>
            </el-table-column>

            <el-table-column label="金标配置ID"
                             min-width="220">
              <template slot-scope="scope">
                <remote-select
                  v-model="scope.row.exam_task_cfg_id"
                  placeholder="请选择金标"
                  :disabled="parseInt(scope.row.enable_exam_task) !== 1"
                  clearable
                  style="width: 220px"
                  id-key="id"
                  label-key="standard_order_id"
                  value-key="id"
                  :query-request="queryExamTaskTable"
                  :query-params="{}"
                  :find-request="getExamTaskDetail" />
              </template>
            </el-table-column>

            <el-table-column label="开启2人审核"
                             min-width="160">
              <template slot-scope="scope">
                <el-switch
                  v-model="scope.row.enable_two_people"
                  :active-value="1"
                  :inactive-value="0" />
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>

        <el-row class="form-panel">
          <el-button type="primary"
                     @click="onSubmit">保存
          </el-button>
          <el-button @click="$router.back()">返回</el-button>
        </el-row>
      </el-form>
    </layout-panel>
  </div>
</template>

<script>
export default {
  data () {
    return {
      formRules: {
        customerid: [{required: true, message: '请选择客户', trigger: 'change'}],
        projectid: [{required: true, message: '请选择项目', trigger: 'change'}],
      },
      selectedBatchIds: [],
      form: {
        id: null,
        customerid: null,
        customername: '',
        customernumber: '',
        projectid: null,
        projectname: '',
        projectnumber: '',
        status: 1,
        setting_config_json: {
          is_project_audit: 1,
          batch_audit_cfg: [],
        },
      },
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => vm.onLoad())
  },
  beforeRouteUpdate (to, from, next) {
    this.onReload()
    next()
  },
  created () {},
  watch: {
    // 多选组件可能是原地修改数组，deep 确保变更能触发联动逻辑
    selectedBatchIds: {
      deep: true,
      handler (val) {
        this.syncBatchAuditCfg(val)
      },
    },
    'form.setting_config_json.is_project_audit': {
      handler (val) {
        // 项目维度审单：允许不配置批次，但仍支持编辑批次选择
      },
    },
  },
  methods: {
    ...request.map([
      'getCustomerTable',
      'getCustomerDetail',
      'getBaiscProjectTable',
      'getProjectDetail',
      'getBatchTable',
      'getBatchDetail',
      'queryExamTaskTable',
      'getExamTaskDetail',
    ]),
    onLoad () {
      if (this.$route.params.id) {
        this.setForm(this.id = this.$route.params.id)
      }
    },
    onReload () {
      Object.assign(this.$data, this.$options.data())
      this.onLoad()
    },
    setForm (id) {
      request.page('getAuditTaskSetting', {id}).then(({data}) => {
        filter.setLoop(this.form, data)

        this.form.customerid = String(this.form.customerid)
        this.form.projectid = String(this.form.projectid)

        this.selectedBatchIds = this.form.setting_config_json.batch_audit_cfg.map(it => String(it.batchid))
      })
    },
    onCustomerChanged (item) {
      // RemoteSelect change 回传选中对象；新建时用于补齐后端必填字段
      if (!item) {
        this.form.customername = ''
        this.form.customernumber = ''
        this.form.projectid = null
        this.form.projectname = ''
        this.form.projectnumber = ''
        this.selectedBatchIds = []
        this.form.setting_config_json.batch_audit_cfg = []
        return
      }
      this.form.customername = item.customername || item.name || ''
      this.form.customernumber = item.customernumber || item.number || ''

      // 切换客户后，项目与批次依赖客户，需要清空
      this.form.projectid = null
      this.form.projectname = ''
      this.form.projectnumber = ''
      this.selectedBatchIds = []
      this.form.setting_config_json.batch_audit_cfg = []
    },
    onProjectChanged (item) {
      if (!item) {
        this.form.projectname = ''
        this.form.projectnumber = ''
        this.selectedBatchIds = []
        this.form.setting_config_json.batch_audit_cfg = []
        return
      }
      this.form.projectname = item.projectname || item.name || ''
      this.form.projectnumber = item.projectnumber || item.number || ''

      // 切换项目后，批次依赖项目，需要清空
      this.selectedBatchIds = []
      this.form.setting_config_json.batch_audit_cfg = []
    },
    onEnableExamTaskChange (row) {
      const enabled = parseInt(row.enable_exam_task) === 1
      if (!enabled) {
        row.exam_task_cfg_id = null
      }
    },
    syncBatchAuditCfg (batchIds) {
      const ids = (batchIds || [])
        .map(id => parseInt(id))
        .filter(id => !Number.isNaN(id))

      const existed = this.form.setting_config_json.batch_audit_cfg || []
      const existedMap = new Map(existed.map(r => [parseInt(r.batchid), r]))

      const nextCfg = []
      ids.forEach((batchid) => {
        if (existedMap.has(batchid)) {
          nextCfg.push(existedMap.get(batchid))
        } else {
          nextCfg.push({
            batchid,
            enable_exam_task: 0,
            exam_task_cfg_id: null,
            enable_two_people: 0,
          })
        }
      })

      nextCfg.forEach((row) => {
        row.batchid = row.batchid === null || row.batchid === undefined ? null : parseInt(row.batchid)
        row.enable_exam_task = parseInt(row.enable_exam_task)
        row.enable_two_people = parseInt(row.enable_two_people)

        if (row.enable_exam_task !== 1) {
          row.exam_task_cfg_id = null
        } else {
          row.exam_task_cfg_id = row.exam_task_cfg_id === null || row.exam_task_cfg_id === undefined || row.exam_task_cfg_id === ''
            ? null
            : parseInt(row.exam_task_cfg_id)
        }
      })

      this.form.setting_config_json.batch_audit_cfg = nextCfg
    },
    onSubmit () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          this.$message.error('提交内容填写不正确！')
          return
        }
        const isProjectAudit = parseInt(this.form.setting_config_json.is_project_audit) === 1
        if (!isProjectAudit && (!this.selectedBatchIds || this.selectedBatchIds.length === 0)) {
          this.$message.error('请至少选择一个批次')
          return
        }

        const batchAuditCfg = (this.form.setting_config_json.batch_audit_cfg || []).map((row) => {
          const enableExamTask = parseInt(row.enable_exam_task)
          const examTaskCfgId = enableExamTask === 1
            ? (row.exam_task_cfg_id === null || row.exam_task_cfg_id === undefined || row.exam_task_cfg_id === ''
              ? null
              : parseInt(row.exam_task_cfg_id))
            : null

          if (enableExamTask === 1 && (examTaskCfgId === null || Number.isNaN(examTaskCfgId))) {
            this.$message.error(`开启金标时 金标配置ID 必填（批次ID: ${row.batchid}）`)
            return null
          }

          return {
            batchid: parseInt(row.batchid),
            enable_exam_task: enableExamTask,
            exam_task_cfg_id: examTaskCfgId,
            enable_two_people: parseInt(row.enable_two_people),
          }
        })

        if (batchAuditCfg.some(x => x === null)) {
          return
        }

        const payload = {
          customerid: parseInt(this.form.customerid),
          customername: this.form.customername,
          customernumber: this.form.customernumber,
          projectid: parseInt(this.form.projectid),
          projectname: this.form.projectname,
          projectnumber: this.form.projectnumber,
          setting_config_json: {
            is_project_audit: parseInt(this.form.setting_config_json.is_project_audit),
            batch_audit_cfg: batchAuditCfg,
          },
        }

        const apiName = this.form.id ? 'updateAuditTaskSetting' : 'createAuditTaskSetting'
        const submitData = this.form.id ? Object.assign({id: this.form.id}, payload) : payload

        request.common(apiName, submitData).then(() => {
          this.$message.success(this.form.id ? '修改成功' : '创建成功')
          this.$router.push({path: '/audit-task-setting/table'})
        })
      })
    },
  },
}
</script>

<style lang="scss">
/* 表单项内容区域最大宽度50%（与其他表单页面保持一致） */
.form-content-half .el-form-item__content {
  max-width: 50%;
}

/* 表单底部操作面板（与其他表单页面保持一致） */
.form-panel {
  margin: 20px 0 0;
}
</style>




// WEBPACK FOOTER //
// src/views/audit-task-setting/pages/AuditTaskSettingFormPage.vue